import { render, staticRenderFns } from "./AwsFilesEdit.vue?vue&type=template&id=41294936&scoped=true"
import script from "./AwsFilesEdit.vue?vue&type=script&lang=ts"
export * from "./AwsFilesEdit.vue?vue&type=script&lang=ts"
import style0 from "./AwsFilesEdit.vue?vue&type=style&index=0&id=41294936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41294936",
  null
  
)

export default component.exports